import { useContext } from "react";
import { CurrentPage } from "../../../models";
import { Context } from "../../../GAContext";
import ReactGA from "react-ga4";

export const useTrackingEvents = () => {
  const [GaEvent] = useContext(Context);
  const handleSearchTracking = (isAiMode?: boolean) => {
    const baseLabel = {
      [CurrentPage.home]: "Submit teksta pretrage - naslovna",
      [CurrentPage.search]: "Submit teksta pretrage - rezultati pretrage",
      [CurrentPage.details]: "Submit teksta pretrage - detalji oglasa",
      [CurrentPage.myAds]: "Submit teksta pretrage - moji oglasi",
      [CurrentPage.module]: "Submit teksta pretrage - stranica kategorije",
    }[GaEvent]

    const label = baseLabel ? (isAiMode ? `${baseLabel} AI` : baseLabel) : "";

    if (GaEvent) {
      ReactGA.event({
        category: "Pretraga",
        action: "Click",
        label: label
      });
    }
  }

  const handleSuggestedOptionTracking = () => {
    // Ga event triggered by picking suggestion on keyboard arrows
    const label = {
      [CurrentPage.home]: "Odabir ponuđene pretrage - naslovna",
      [CurrentPage.search]: "Odabir ponuđene pretrage - rezultati pretrage",
      [CurrentPage.details]: "Odabir ponuđene pretrage - detalji oglasa",
      [CurrentPage.myAds]: "Odabir ponuđene pretrage - moji oglasi",
      [CurrentPage.module]: "Odabir ponuđene pretrage - stranica kategorije",
    }[GaEvent]


    if (GaEvent) {
      ReactGA.event({
        category: "Pretraga",
        action: "Click",
        label: label || ""
      });
    }

  }

  const trackClickEvent = (isAiMode?: boolean) => {
    const baseLabel = {
      [CurrentPage.home]: "Unos teksta pretrage - naslovna",
      [CurrentPage.search]: "Unos teksta pretrage - rezultati pretrage",
      [CurrentPage.details]: "Unos teksta pretrage - detalji oglasa",
      [CurrentPage.myAds]: "Unos teksta pretrage - moji oglasi",
      [CurrentPage.module]: "Unos teksta pretrage - stranica kategorije",
    }[GaEvent]

    const label = baseLabel ? (isAiMode ? `${baseLabel} AI` : baseLabel) : "";

    if (GaEvent != "") {
      ReactGA.event({
        category: "Pretraga",
        action: "Click",
        label: label
      });
    }
  };

  const trackSearchModeChange = (isAiMode: boolean) => {
    ReactGA.event({
      category: "Tekstualna pretraga",
      action: "Click",
      label: isAiMode ? "Promena na AI pretragu" : "Promena na klasičnu pretragu"
    });
  };

  const handleRecentSearchTracking = () => {
    const label = {
      [CurrentPage.home]: "Odabir Prethodne Pretrage - naslovna",
      [CurrentPage.search]: "Odabir Prethodne Pretrage - rezultati pretrage",
      [CurrentPage.details]: "Odabir Prethodne Pretrage - detalji oglasa",
      [CurrentPage.myAds]: "Odabir Prethodne Pretrage - moji oglasi",
      [CurrentPage.module]: "Odabir Prethodne Pretrage - stranica kategorije",
    }[GaEvent];

    if (GaEvent) {
      ReactGA.event({
        category: "Pretraga",
        action: "Click",
        label: label || "",
      });
    }
  };

  const trackViewingOfSearchResults = (obj) => {
    ReactGA.event("view_search_results", obj);
  }


  return {
    handleSearchTracking,
    handleSuggestedOptionTracking,
    handleRecentSearchTracking,
    trackClickEvent,
    trackSearchModeChange,
    trackViewingOfSearchResults
  }
}


// WEBPACK FOOTER //
// ./src/containers/HomePage/hooks/useTrackingEvents.ts